import React, { useContext, useEffect, useState } from 'react'
import { AppState } from '../App'
import { TailSpin } from 'react-loader-spinner';
import { message } from 'antd';

const Claim = () => {
    const useAppState = useContext(AppState);
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);
    const [isRoyaltyAvl, setIsRoyaltyAvl] = useState(false);
    const [royalty, setRoyalty] = useState(0);
    const [lifestyle, setLifestyle] = useState(0);
    const [isLifestyleAvl, setIsLifestyleAvl] = useState([false, false, false, false, false]);
    const [isLifestyleUpdateAvl, setIsLifestyleUpdateAvl] = useState(false);
    const [clubs, setClubs] = useState(["Prime Club", "Elite Club", "Royal Club", "Crown Club", "Supereme Club"]);

    useEffect(() => {
      async function getData() {
        setIsRoyaltyAvl(false);
        for(let i=0; i<6; i++) {
          let isAvl = await useAppState.staticContract.isRoyaltyAvl(useAppState.id, i);
          if(isAvl) {
            setIsRoyaltyAvl(true);
            setRoyalty(i);
          }
        }
        
        let _isAvl = [false, false, false, false, false];
        for(let i=0; i<5; i++) {
          let isAvl = await useAppState.staticContract.isLifestyleAvl(useAppState.id, i);
          _isAvl[i] = isAvl;
        }
        setIsLifestyleAvl(_isAvl);

        let isUpdateAvl = await useAppState.staticContract.isLifestyleUpdateAvl(useAppState.id);
        setIsLifestyleUpdateAvl(isUpdateAvl);
      }
      getData();
    },[useAppState.change, useAppState.walletAddress, useAppState.id])

    const claimRoyalty = async () => {
      setLoading(true);
      try {
        const contract = await useAppState.getContract();
        let tx = await contract.claimRoyalty(royalty);
        await tx.wait();
        message.success("Sucessfully Claimed");
      } catch (error) {
        message.error(error.reason)
      }
      setLoading(false);
    }

    const claimLifestyle = async (i) => {
      setLoading2(true);
      try {
        const contract = await useAppState.getContract();
        let tx = await contract.claimLifestyle(i);
        await tx.wait();
        message.success("Sucessfully Claimed");
      } catch (error) {
        message.error(error.reason)
        console.log(error)
      }
      setLoading2(false);
    }

    const updateLifestyle = async () => {
      setLoading3(true);
      try {
        const contract = await useAppState.getContract();
        let tx = await contract.updateLifestyleLevel(useAppState.id);
        await tx.wait();
        message.success("Sucessfully Updated");
      } catch (error) {
        message.error(error.reason)
        console.log(error);
      }
      setLoading3(false);
    }

  return (
    <div>
        {isRoyaltyAvl ? <div className='flex justify-between items-center bg-[#1e2026] bg-opacity-40 p-4 rounded-lg'>
            <span>Royalty Claim</span>
            <button onClick={claimRoyalty} className='bg-lime-500 text-white font-semibold px-2 py-2 rounded-md'>{loading ? <TailSpin color='white' height={14} /> : "Claim"}</button>
        </div> : null}
        {isLifestyleAvl.map((e, i) =>  {
          return (
            e ? 
            <div className='mt-4 flex justify-between items-center bg-[#1e2026] bg-opacity-40 p-4 rounded-lg'>
                <span>{clubs[i]} Claim</span>
                <button onClick={() => claimLifestyle(i)} className='bg-lime-500 text-white font-semibold px-2 py-2 rounded-md'>{loading2 ? <TailSpin color='white' height={14} /> : "Claim"}</button>
            </div>
            : null
          )
        })}
        {isLifestyleUpdateAvl ?
        <div className='mt-4 flex justify-between items-center bg-[#1e2026] bg-opacity-40 p-4 rounded-lg'>
            <span>Lifestyle Update</span>
            <button onClick={updateLifestyle} className='bg-lime-500 text-white font-semibold px-2 py-2 rounded-md'>{loading3 ? <TailSpin color='white' height={14} /> : "Update"}</button>
        </div>
        : null}
    </div>
  )
}

export default Claim